import React from 'react'
import smoothscroll from 'smoothscroll-polyfill'
import { MapiProvider } from './src/context/MapiProvider'
import { UserProvider } from './src/context/UserProvider'
import { PhoneAvailabilityProvider } from './src/context/PhoneAvailabilityProvider'

// wrapRootElement is part of the Gatsby API, and thus cannot be the default export
/* eslint-disable import/prefer-default-export, react/jsx-filename-extension */
export const wrapRootElement = ({ element }, config) => (
  <MapiProvider
    mapiConfig={{
      analyticsId: config.analyticsId,
      brandToken: config.mapiBrandToken,
      brandTokens: config.mapiBrandTokens,
      siteURL: config.siteURL,
      defaultPhone: config.defaultPhone,
      defaultPromoCode: config.defaultPromoCode,
      phoneSymbol: config.phoneSymbol,
      chatEnabled: config.chatEnabled,
      cprPriority: config.cprPriority,
    }}
  >
    <PhoneAvailabilityProvider
      brand={config.mapiBrandToken}
      domain={config.cobra?.sitePath || ''}
    >
      <UserProvider>{element}</UserProvider>
    </PhoneAvailabilityProvider>
  </MapiProvider>
)

export const onClientEntry = () => smoothscroll.polyfill()
